import React from 'react'
import { Link } from 'react-router-dom'
import { Button } from 'reactstrap'

const PathogenServicesChicago = () => {
  return (
    <div id='website-responsive'>
        <div className='left-padding10rem1 right-padding10rem1 '>
        <div className='left-padding8rem right-padding8rem py-md-5 py-4'>
            <div className='py-4' style={{ boxShadow:'0 0 10px 0 rgba(0,0,0,.5)'}}>
                <div className='fs-ss-20 text-montserrat fw-700 text-ss-black lh-1-2 px-md-5 pt-3'>
                    <center>
                        Need Respiratory Pathogen Panel Testing Services in Chicago?
                    <hr className='hr-style my-md-2 mt-2 mt-md-3' style={{ width:'130px', marginTop:'2px', marginBottom:'4px'}}/>
                    </center>
                </div>

                <div className='py-3'>
                <center>
                <Link to='/book-panel-test-appointment'>
                <Button className='btn-ss-secondary rounded20 ' style={{  boxShadow:'1px 1px 6px 0 rgba(0,0,0,.4)'}}>
                    <text className='text-montserrat fw-600 fs-ss-16' style={{ padding:'12px 14px',}}>
                        Book Appointment
                    </text>
                </Button>
                </Link>
                </center>
                </div>
            </div>
            </div>
        </div>
    </div>
  )
}

export default PathogenServicesChicago